define('AnimatedBackground',['jquery', 'gsap', 'ScrollMagic', 'AnimationPlugin', 'ANSI/Utility/Dimensions', 'ANSI/Utility/SitecoreUtils', 'promise-polyfill'], function (
    $,
    gsap,
    ScrollMagic,
    AnimationPlugin,
    dimensions,
    sitecoreUtils
) {
    var animations = {
        init: function () {
            if ($('.animated-background').length && dimensions.width > 991) {
                animations.backgroundScrollAnimation();
            }
        },
        backgroundScrollAnimation: function () {
            var ctrl = new ScrollMagic.Controller({});

            $('.animated-background').each(function () {
                new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 0.5,
                    duration: dimensions.height * 1.5
                })
                    .setTween(this, 0.5, {
                        backgroundPosition: '100% 100%'
                    })
                    .addTo(ctrl);
            });
        }
    };
    if (!sitecoreUtils.prototype.isEditing()) Promise.resolve().then(animations.init);
});

